import Filter from "../../../../models/Filter";
import {
  pathogenicityIndex,
  pathogenicityFiltersCNV,
} from "../../constants/pathogenicity";
import {
  INVERSION,
  BREAKEND,
  DUPLICATION,
  INSERTION,
  DELETION,
  TANDEM_DUP,
  REPEAT_EXPANSION,
} from "../../constants/structuralVariants";

function getFilters(otherSamples = []) {
  return [
    ...otherSamples.map(
      (x) =>
        new Filter({
          category: "CNV In Any other Sample",
          disableCategoryNum: true,
          key: `any-sample-${x.name}`,
          label: `${x.name}`,
          isVisible: true,
        })
    ),
    ...otherSamples.map(
      (x) =>
        new Filter({
          category: "CNV In All other Samples",
          disableCategoryNum: true,
          key: `all-sample-${x.name}`,
          label: `${x.name} `,
          isVisible: true,
        })
    ),
    ...otherSamples.map(
      (x) =>
        new Filter({
          category: "CNV Not in Sample",
          disableCategoryNum: true,
          key: `not-sample-${x.name}`,
          label: `${x.name}  `,
          isVisible: true,
        })
    ),
    ...Array.from(new Set(Object.values(pathogenicityIndex)))
      .filter((x) => pathogenicityFiltersCNV[x])
      .map(
        (x) =>
          new Filter({
            category: "Pathogenicity",
            key: `pathogenicity-${x}`,
            value: 0,
            isVisible: true,
            totalCount: 0,
            label: pathogenicityFiltersCNV[x],
          })
      ),

    new Filter({
      category: "Type",
      key: DELETION,
      value: 0,
      isVisible: true,
      totalCount: 0,
      label: "Deletion",
    }),
    new Filter({
      category: "Type",
      key: DUPLICATION,
      value: 0,
      isVisible: true,
      totalCount: 0,
      label: "Duplication",
    }),
    new Filter({
      category: "Type",
      key: INVERSION,
      value: 0,
      isVisible: true,
      totalCount: 0,
      label: "Inversion",
    }),
    new Filter({
      category: "Type",
      key: INSERTION,
      value: 0,
      isVisible: true,
      totalCount: 0,
      label: "insertion",
    }),
    new Filter({
      category: "Type",
      key: TANDEM_DUP,
      value: 0,
      isVisible: true,
      totalCount: 0,
      label: "Tandem Duplication",
    }),
    new Filter({
      category: "Type",
      key: REPEAT_EXPANSION,
      value: 0,
      isVisible: true,
      totalCount: 0,
      label: "Repeat Expansion",
    }),
    new Filter({
      category: "Type",
      key: BREAKEND,
      value: 0,
      isVisible: true,
      totalCount: 0,
      label: "Breakend",
    }),
    new Filter({
      key: `quality-1`,
      value: 0,
      label: "Failed no quality checks",
      isVisible: true,
      category: "Quality",
    }),
    new Filter({
      key: `quality-2`,
      value: 0,
      label: "Failed some quality checks",
      isVisible: true,
      category: "Quality",
    }),
    new Filter({
      key: `quality-3`,
      value: 0,
      label: "Failed all quality checks",
      isVisible: true,
      category: "Quality",
    }),
  ];
}

export default getFilters;
